import React from 'react';
import { Link } from 'react-router-dom';
type Variant = 'primary' | 'secondary' | 'ghost' | 'link';
type Size = 'sm' | 'md';
const base = 'inline-flex items-center justify-center gap-1.5 rounded font-semibold transition-colors disabled:cursor-not-allowed';
const variants: Record<Variant, string> = {
  primary: 'bg-brand-600 text-white hover:bg-brand-700 disabled:bg-brand-300 disabled:hover:bg-brand-300',
  secondary: 'border border-ink-300 bg-white text-ink-700 hover:bg-ink-50 disabled:text-ink-400 disabled:border-ink-200',
  ghost: 'text-ink-600 hover:bg-ink-100',
  link: 'text-brand-600 hover:text-brand-700 hover:underline'
};
const sizes: Record<Size, string> = {
  sm: 'h-8 px-3 text-[13px]',
  md: 'h-9 px-3.5 text-[13px]'
};
interface BaseProps {
  children: React.ReactNode;
  variant?: Variant;
  size?: Size;
  className?: string;
  fullWidth?: boolean;
}
interface ButtonProps extends BaseProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'button' | 'submit';
  disabled?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  fullWidth,
  onClick,
  type = 'button',
  disabled
}: ButtonProps) {
  return <button type={type} onClick={onClick} disabled={disabled} className={`${base} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-299" data-mp="tnosij9f9kys">
      {children}
    </button>;
}
interface ButtonLinkProps extends BaseProps {
  to: string;
}
export function ButtonLink({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  fullWidth,
  to
}: ButtonLinkProps) {
  return <Link to={to} className={`${base} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-300" data-mp="17ebow4rpmyrp">
      {children}
    </Link>;
}